var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.productColor),attrs:{"id":"backoffice"}},[_c('router-view',{key:_vm.currentClientId})],1)}
var staticRenderFns = []

export { render, staticRenderFns }